import { render } from "./ReviewChangeProposalsModal.vue?vue&type=template&id=1b123422&scoped=true"
import script from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js"
export * from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js"

import "./ReviewChangeProposalsModal.vue?vue&type=style&index=0&id=1b123422&lang=scss"
import "./ReviewChangeProposalsModal.vue?vue&type=style&index=1&id=1b123422&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b123422"],['__file',"src/common/components/ReviewChangeProposalsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b123422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b123422', __exports__)) {
    api.reload('1b123422', __exports__)
  }
  
  module.hot.accept("./ReviewChangeProposalsModal.vue?vue&type=template&id=1b123422&scoped=true", () => {
    api.rerender('1b123422', render)
  })

}


export default __exports__